<!-- *graphicsId的主题，同步后还没有看过实际展示效果，等看过后，则证明迁移成功，可以移除以前就得 cup_themeItem 文件 -->
<template>
  <div
    class="themeItem_box"
    :class="[
      mode,
      width100ThemeGraphicsIds.includes(themeItem.graphicsId)
        ? width100ThemeGraphicsIdsClassName[
            width100ThemeGraphicsIds.indexOf(themeItem.graphicsId)
          ]
        : '',
    ]"
    :style="{ '--mixtmt_mixvw': cssDynamicObj.mixvw }"
    v-if="currThemeObj"
  >
    <!-- <div class="themeItem_title" v-text="themeItem.analysisItemName"></div> -->
    <div
      class="themeItem_title"
      :style="{
        '--mixtmt_themeClipPathSize': themeClipPathSize,
      }"
    >
      <span class="themeItemTitle_bg">
        <span class="actTab"></span>
      </span>
      <span
        class="themeItemTitle_name"
        v-text="themeItem.analysisItemName"
      ></span>
      <span
        class="themeItemTitle_styleName"
        v-text="themeItem.title2RightName"
      ></span>
    </div>
    <div class="themeItemMain_bg">
      <div
        class="themeItem_main"
        :class="
          isDraggable
            ? ''
            : themeItem.isMediaBroadcastFlag
            ? 'slideR2L'
            : 'slideL2R'
        "
        v-if="themeItem.renderData"
      >
        <template v-if="themeItem.isMediaBroadcastFlag">
          <!-- 媒体云下广播级 图片  -->
          <HTML_MEDIAPIC
            v-if="
              themeItem.isMediaBroadcastFlag &&
              themeItem.currPreviewType === 'pic'
            "
            :datas="themeItem"
          ></HTML_MEDIAPIC>

          <!-- 媒体云下广播级 视频  -->
          <HTML_MEDIAVIDEO
            v-if="
              themeItem.isMediaBroadcastFlag &&
              themeItem.currPreviewType === 'video'
            "
            :datas="themeItem"
          ></HTML_MEDIAVIDEO>
        </template>
        <template v-else>
          <!-- *graphicsId: 1 -- 近期战绩 -->
          <CANVAS_PIE_RECENTACH
            v-if="themeItem.graphicsId == 1"
            :datas="themeItem.renderData"
          ></CANVAS_PIE_RECENTACH>

          <!-- *graphicsId: 2 -- 交锋记录 -->
          <HTML_CONFRRECORD
            v-if="themeItem.graphicsId == 2"
            :datas="themeItem.renderData"
          ></HTML_CONFRRECORD>

          <!-- graphicsId: 3 -- 球员信息 -->
          <HTML_FB_PLAYERINFOR
            v-if="themeItem.graphicsId == 3"
            :datas="themeItem.renderData"
          ></HTML_FB_PLAYERINFOR>

          <!-- graphicsId: 4 -- 球队信息 -->
          <HTML_FB_TEAMINFOR
            v-if="themeItem.graphicsId == 4"
            :datas="themeItem.renderData"
          ></HTML_FB_TEAMINFOR>

          <!-- graphicsId: 5 -- 球员数据对比 [bar类型] -->
          <HTML_BAR_BOTHSIDEPLAYER
            v-if="themeItem.graphicsId == 5"
            :isPlayer="true"
            :datas="themeItem.renderData"
          ></HTML_BAR_BOTHSIDEPLAYER>

          <!-- graphicsId: 6 -- 球队数据对比 [bar类型]-->
          <HTML_BAR_BOTHSIDEPLAYER
            v-if="themeItem.graphicsId == 6"
            :isPlayer="false"
            :datas="themeItem.renderData"
          ></HTML_BAR_BOTHSIDEPLAYER>

          <!-- graphicsId: 7 -- 主队常用阵容 -->
          <CANVAS_PIE_COMLINEUP
            v-if="themeItem.graphicsId == 7"
            :datas="themeItem.renderData"
          ></CANVAS_PIE_COMLINEUP>

          <!-- graphicsId: 8 -- 足球-双方球队首发阵容 -->
          <!-- <Lineup_doubleTeam
            v-if="themeItem.graphicsId == 8"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            themeClass="onlyDisplay"
          ></Lineup_doubleTeam> -->
          <Lineup_horizontalPGA
            v-if="themeItem.graphicsId == 8"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            themeClass="onlyDisplay"
          ></Lineup_horizontalPGA>

          <!-- graphicsId: 9 -- 客队常用阵容 -->
          <CANVAS_PIE_COMLINEUP
            v-if="themeItem.graphicsId == 9"
            :datas="themeItem.renderData"
          ></CANVAS_PIE_COMLINEUP>

          <!-- graphicsId: 12 -- 比赛 -->
          <html_FB_seasonMatch
            v-if="themeItem.graphicsId == 12"
            :pareData="themeItem.renderData"
            themeClass="broadcastList"
          ></html_FB_seasonMatch>

          <!-- graphicsId: 13 -- 进球 -->
          <html_FB_seasonGoal
            v-if="themeItem.graphicsId == 13"
            :pareData="themeItem.renderData"
            themeClass="broadcastList"
          ></html_FB_seasonGoal>

          <!-- graphicsId: 14 -- 进球时间分布 -->
          <html_FB_seasonGoalTime
            v-if="themeItem.graphicsId == 14"
            :pareData="themeItem.renderData"
            themeClass="broadcastList"
          ></html_FB_seasonGoalTime>

          <!-- graphicsId: --15: 数据中心 球队数据 球队进球 [足球球队进球等等，支持竖向滚动]； 16:单人 球员榜单 [足球射手榜等等，支持竖向滚动] -->
          <HTML_CARDLIST
            v-if="[15, 16].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
          ></HTML_CARDLIST>

          <!-- *graphicsId: 17 -- 射门分布 -->
          <CANVAS_SHOOTINGSTEREOGRAM
            v-if="themeItem.graphicsId == 17"
            :datas="themeItem.renderData"
          ></CANVAS_SHOOTINGSTEREOGRAM>

          <!-- graphicsId:18  -- 进球控球链 -->
          <CANVAS_FB_BALLCONTROLCHAIN
            v-if="themeItem.graphicsId == 18"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :tipFontFlag="true"
          ></CANVAS_FB_BALLCONTROLCHAIN>

          <!-- *graphicsId: 19 -- 防守区域 -->
          <CANVAS_REGIONALCOVERAGE
            v-if="themeItem.graphicsId == 19"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></CANVAS_REGIONALCOVERAGE>

          <!-- *graphicsId: 20 -- 跑区热力图 -->
          <HEATMAP
            v-if="themeItem.graphicsId == 20"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HEATMAP>

          <!-- graphicsId: 21 -- 数据分析-球员数据对比【雷达图】 -->
          <CANVAS_RADAR_PLAYERSINFOR
            v-if="themeItem.graphicsId == 21"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></CANVAS_RADAR_PLAYERSINFOR>

          <!-- graphicsId: 23 -- 世界杯 -【晋级图】 -->
          <HTML_KNOCKOUT_T4T6T8
            v-if="themeItem.graphicsId == 23"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :themeMode="['hideHeader']"
            themeClass="onlyDisplay"
          ></HTML_KNOCKOUT_T4T6T8>

          <!-- graphicsId: 24 -- 世界杯 - 单个球队阵容（单个球队首发阵容） -->
          <Lineup_horizontalPGA
            v-if="themeItem.graphicsId == 24"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            themeClass="onlyDisplay"
          ></Lineup_horizontalPGA>

          <!-- graphicsId: 25 -- 胜率预测 -->
          <WINRATEPREDICTION_BAR
            v-if="themeItem.graphicsId == 25"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></WINRATEPREDICTION_BAR>

          <!-- graphicsId: 26 -- 世界杯 - 单支球队评分【首发阵容球员+已上场替补球员 的评分+事件】 -->
          <!-- 竖版 球场 -->
          <!-- <HTML_LINEUP_SINGLETEAM
            v-if="themeItem.graphicsId == 26"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_LINEUP_SINGLETEAM> -->
          <Complex_doubleTeam
            v-if="themeItem.graphicsId == 26"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            themeClass="onlyDisplay"
          ></Complex_doubleTeam>

          <!-- graphicsId: 27 -- 比赛态势 -->
          <MATCHSTATE_KEYEVENT_BAR
            v-if="themeItem.graphicsId == 27"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></MATCHSTATE_KEYEVENT_BAR>

          <!-- graphicsId: 28 -- 射门分布及期望进球 -->
          <SHOOTDIS_EXPECTEDGOAL_SCATTER
            v-if="themeItem.graphicsId == 28"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></SHOOTDIS_EXPECTEDGOAL_SCATTER>

          <!-- graphicsId: 29 -- 球员平均占位 -->
          <PLAYER_AVERAGEROCCUPANCY_SCATTER
            v-if="themeItem.graphicsId == 29"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></PLAYER_AVERAGEROCCUPANCY_SCATTER>

          <!-- graphicsId: 30 -- 球员信息对比 -->
          <HTML_FB_TEMAPLAYERINFOR_DOUBLE
            v-if="themeItem.graphicsId == 30"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_FB_TEMAPLAYERINFOR_DOUBLE>

          <!-- graphicsId: 31 -- 球队信息对比 -->
          <HTML_FB_TEMAPLAYERINFOR_DOUBLE
            v-if="themeItem.graphicsId == 31"
            :isPlayer="false"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_FB_TEMAPLAYERINFOR_DOUBLE>

          <!-- graphicsId: 32 -- 传球风格 -->
          <PASSINGSTYLE_PIE
            v-if="themeItem.graphicsId == 32"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></PASSINGSTYLE_PIE>

          <!-- graphicsId: 33 -- 球队跑区热力图 -->
          <HEATMAP
            v-if="themeItem.graphicsId == 33"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :heatWeight="0.35"
          ></HEATMAP>

          <!-- graphicsId: 34 -- 球员跑区热力图 -->
          <HEATMAP
            v-if="themeItem.graphicsId == 34"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :heatWeight="0.45"
          ></HEATMAP>

          <!-- graphicsId: 35 -- 网球-球员数据对比【雷达图】 -->
          <TENNIS_RADAR_PLAYERINFOR
            v-if="themeItem.graphicsId == 35 && themeItem?.renderData?.competitionType === 'chinaOpen'"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></TENNIS_RADAR_PLAYERINFOR>

          <!-- graphicsId: 35 -- 数据分析-球队数据对比【雷达图】 -->
          <CANVAS_RADAR_PLAYERSINFOR
            v-else-if="themeItem.graphicsId == 35"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :themeType="'team'"
          ></CANVAS_RADAR_PLAYERSINFOR>

          <!-- graphicsId: 37 -- 足球-双方球员评分【首发阵容+替补阵容+评分（球队+球员 ）】 -->
          <Complex_doubleTeam
            v-if="themeItem.graphicsId == 37"
            :datas="themeItem.renderData"
            :themeItem_titleList="['首发阵容', '替补阵容(仅含已上场球员)']"
            themeClass="onlyDisplay"
          ></Complex_doubleTeam>

          <!-- graphicsId: 38 --【足球世界杯|足球联赛】 今日赛程 【支持竖向滚动】-->
          <HTML_TODAYSCHEDULE
            v-if="[38].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :matchModeObj="matchModeObjHandler(themeItem)"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 39 --【足球世界杯】赛程预告 -->
          <HTML_TODAYSCHEDULE
            v-if="[39].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :matchModeObj="matchModeObjHandler(themeItem)"
            viewMode="scheduleNoticeFootballCup"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 41 --触球热区带6个统计项 -->
           <SITUATION_MAP
            v-if="themeItem.graphicsId == 41"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :heatWeight="0.35"
          ></SITUATION_MAP>

          <!-- graphicsId: 42 --射门分析 -->
           <HTML_SHOOTANALYSIS
            v-if="themeItem.graphicsId == 42"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_SHOOTANALYSIS>

          <!-- *graphicsId:  -- 反击效率 -->
          <CANVAS_SCATTER_COORDINATSYS
            v-if="themeItem.graphicsId == 101"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></CANVAS_SCATTER_COORDINATSYS>

          <!-- *graphicsId:  -- 期望进球 -->
          <CANVAS_GRAPH_EXPECTGOAL
            v-if="themeItem.graphicsId == 102"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></CANVAS_GRAPH_EXPECTGOAL>

          <!-- graphicsId: 1001 -- 马拉松-报名数据 -->
          <HTML_SIGNUPDATA
            v-if="themeItem.graphicsId == 1001"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_SIGNUPDATA>

          <!-- graphicsId: 1002 -- 马拉松-年龄分布 -->
          <PLAYERAGERADAR
            v-if="themeItem.graphicsId == 1002"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></PLAYERAGERADAR>

          <!-- graphicsId: 1003 -- 马拉松-选手地域分布 -->
          <PLAYERDISTRIBUTEPIE
            v-if="themeItem.graphicsId == 1003"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></PLAYERDISTRIBUTEPIE>

          <!-- graphicsId: 1004 -- 马拉松-数据监控 -->
          <PLAYERCONTROLPIE
            v-if="themeItem.graphicsId == 1004"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></PLAYERCONTROLPIE>

          <!-- graphicsId: 1006 -- 马拉松-排名【全马排名（男）|全马排名（女）...】【支持竖向滚动】 -->
          <HTML_CARDLIST
            v-if="[1006].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            cType="marathon"
          ></HTML_CARDLIST>

          <!-- graphicsId: -- 奖牌榜 【支持竖向滚动】-->
          <HTML_MEDALTALLY
            v-if="themeItem.graphicsId == 3000"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_MEDALTALLY>

          <!-- graphicsId: 3001 -- 获奖者 -->
          <HTML_MEDALIST
            v-if="themeItem.graphicsId == 3001"
            :datas="themeItem.renderData"
          ></HTML_MEDALIST>

          <!-- graphicsId: 3002 -- MAP || 得分方式 || 数据王  等 -->
          <HTML_PLAYERINFOR
            v-if="themeItem.graphicsId == 3002"
            :datas="themeItem.renderData"
            :inFilter="themeItem.inFilter"
            :cssDynamicObj="cssDynamicObj"
          ></HTML_PLAYERINFOR>

          <!-- graphicsId: 3003 -- 获胜球队 团体 T -->
          <HTML_WINTTEAM_T
            v-if="themeItem.graphicsId == 3003"
            :datas="themeItem.renderData"
          ></HTML_WINTTEAM_T>

          <!-- graphicsId: 3005 -- 超越时刻 -->
          <HTML_BEYONDTHEMOMENT
            v-if="themeItem.graphicsId == 3005"
            :datas="themeItem.renderData"
          ></HTML_BEYONDTHEMOMENT>

          <!-- graphicsId: 3006 -- 接力时刻 -->
          <HTML_RELAYMOMENT
            v-if="themeItem.graphicsId == 3006"
            :datas="themeItem.renderData"
          ></HTML_RELAYMOMENT>

          <!-- graphicsId: 3007 -- 运动员数据对比 || 球队数据对比 || 4人接力展示四个人名 直接展示val string -->
          <HTML_PLAYERDATACOMPARE_ADT
            v-if="[3007].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :inFilter="themeItem.inFilter"
            :cssDynamicObj="cssDynamicObj"
            @inFilterChangeEvent="inFilterChangeEventHandler"
          ></HTML_PLAYERDATACOMPARE_ADT>

          <!-- graphicsId: 3008 -- 运动员数据对比 val需要展示成百分比 per -->
          <HTML_PLAYERDATACOMPARE_PER
            v-if="themeItem.graphicsId == 3008"
            :datas="themeItem.renderData"
          ></HTML_PLAYERDATACOMPARE_PER>

          <!-- graphicsId: 3009 -- 获胜球队 双人 || 单人 A D  -->
          <HTML_WINTTEAM_AD
            v-if="themeItem.graphicsId == 3009"
            :datas="themeItem.renderData"
          ></HTML_WINTTEAM_AD>

          <!-- graphicsId: 3010 -- 本场成绩  -->
          <HTML_LOCALRESULT
            v-if="themeItem.graphicsId == 3010"
            :datas="themeItem.renderData"
          ></HTML_LOCALRESULT>

          <!-- graphicsId: 3011 -- 人名条  -->
          <HTML_PERSONNAMEBAR
            v-if="themeItem.graphicsId == 3011"
            :datas="themeItem.renderData"
          ></HTML_PERSONNAMEBAR>

          <TENNIS_TRACE
            v-if="themeItem.graphicsId == 3034"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></TENNIS_TRACE>

          <!-- graphicsId: 30012 -- 运动员|国家 数据+右侧表格 -->
          <HTML_PLAYERTABLE
            v-if="themeItem.graphicsId == 3012"
            :datas="themeItem.renderData"
            :cssDynamicObj="cssDynamicObj"
          ></HTML_PLAYERTABLE>

          <!-- graphicsId: 30013 -- 左侧[运动员|国家] + 表格 + 右侧[运动员|国家]  -->
          <HTML_PLAYERTABLE_COMBAT
            v-if="themeItem.graphicsId == 3013"
            :datas="themeItem.renderData"
          ></HTML_PLAYERTABLE_COMBAT>

          <!-- graphicsId: -- 综合性赛事（亚运会|大运会...） 今日赛程 【支持竖向滚动】-->
          <HTML_TODAYSCHEDULE
            v-if="themeItem.graphicsId == 3014"
            :datas="themeItem.renderData"
            :matchModeObj="{
              mode: themeItem.renderData.sportType,
            }"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: -- 今日奖牌 【支持竖向滚动】-->
          <HTML_TODAYMEDALDETAIL
            v-if="themeItem.graphicsId == 3015"
            :datas="themeItem.renderData"
          ></HTML_TODAYMEDALDETAIL>

          <!-- graphicsId: -- 对抗类 单队首发阵容 表格类型; [待定:主队阵容] [待定:客队阵容] 【支持竖向滚动】-->
          <HTML_COMBATLINEUP
            v-if="[].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :modeType="'single'"
          ></HTML_COMBATLINEUP>

          <!-- graphicsId: -- 对抗类 双方首发阵容 表格类型; [3016:双方阵容+球员评分一起] 【支持竖向滚动】-->
          <HTML_COMBATLINEUP
            v-if="[3016].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :sportsId="themeItem.disciplineId"
            :modeType="'double'"
          ></HTML_COMBATLINEUP>

          <!-- graphicsId: -- top前三的奖牌榜 【单人|双人|国家】-->
          <HTML_MEDALTOP3
            v-if="themeItem.graphicsId === 3017"
            :datas="themeItem.renderData"
          ></HTML_MEDALTOP3>

          <!-- graphicsId: 3019 -- 分项运动员赛程 【支持竖向滚动】-->
          <HTML_EVENTPLAYERSSCHEDULE
            v-if="themeItem.graphicsId == 3019"
            :datas="themeItem.renderData"
            viewMode="scheduleNotice"
          ></HTML_EVENTPLAYERSSCHEDULE>

          <!-- graphicsId: 3020 -- 上面 对阵信息 + 下面 表格 【表格支持竖向滚动】-->
          <HTML_COMBATTEAMFORTOP
            v-if="themeItem.graphicsId == 3020"
            :datas="themeItem.renderData"
          ></HTML_COMBATTEAMFORTOP>

          <!-- graphicsId: 3021 -- 左边 A|D|T；右边是 bar 条形比例图 【右侧支持竖向滚动】-->
          <HTML_PLAYERINFOR_BAR
            v-if="themeItem.graphicsId == 3021"
            :datas="themeItem.renderData"
          ></HTML_PLAYERINFOR_BAR>

          <!-- graphicsId: -- 原来3023 单个国家的奖牌榜 【全部项目 | 单个项目】-->
          <!-- <HTML_DELEGATIONMEDALTALLY
            v-if="themeItem.graphicsId === 3023"
            :datas="themeItem.renderData"
          ></HTML_DELEGATIONMEDALTALLY> -->

          <!-- graphicsId: -- 单个或多个国家的奖牌榜 【全部项目 | 多个已选+其他项目】-->
          <HTML_DELEGATIONEVENTMEDALTALLY
            v-if="themeItem.graphicsId === 3023"
            :currThemeObj="currThemeObj"
            :datas="themeItem.renderData"
          ></HTML_DELEGATIONEVENTMEDALTALLY>

          <!-- graphicsId: 3024 -- 【综合性运动会|中网】 赛程预告 -->
          <!-- viewMode="scheduleNotice【scheduleNoticeCSMeet|scheduleNoticeTennis】" -->
          <!-- mode: ['compreSportsMeet', 'tennis'] -->
          <HTML_TODAYSCHEDULE
            v-if="[3024].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :matchModeObj="{
              mode: themeItem.renderData.sportType,
            }"
            viewMode="scheduleNotice"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 3025 -- 综合性运动会 对抗类 淘汰赛 | 中网 淘汰赛（区别在于双打）-->
          <COMBAT_DYNAMICDENDRIFORM_KNOCKOUT
            v-if="[3025].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :sportType="
              themeItem.competitionType === 'chinaOpen'
                ? themeItem.sportType
                : ''
            "
            themeClass="onlyDisplay"
            themeContainerWidthStr="100vw - 2 * (9.722vw + 1.388vw + 0.32vw + 1.388vw)"
          ></COMBAT_DYNAMICDENDRIFORM_KNOCKOUT>

          <!-- 单个球队表格 比如【足球】 -->
          <HTML_COMBATLINEUP
            v-if="[3026].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :sportsId="themeItem.disciplineId"
            :modeType="'single'"
          ></HTML_COMBATLINEUP>

          <!-- 复杂表格 比如【混合团体10米气手枪资格赛】 -->
          <HTML_TABLE_EVENTCOP_MODE_21
            v-if="
              [3027].includes(themeItem.graphicsId) &&
              themeItem.renderData?.data?.resultInfo &&
              themeItem.renderData?.data?.scheduleInfo
            "
            :currThemeObj="currThemeObj"
            :currCid="themeItem.competitionId"
            :currSid="themeItem.seasonId"
            :sportsTypeArr="sportsTypeArr"
            :currSportsDetail="{
              sportsId: themeItem.disciplineId,
              sportsName: '',
              eventId: themeItem.eventId,
              eventName: '',
              matchId: '',
            }"
            :datas="themeItem.renderData.data.resultInfo"
            tabType="localData"
            :competitorType="
              themeItem.renderData.data.scheduleInfo.competitorType
            "
            themeClass="onlyDisplay"
          ></HTML_TABLE_EVENTCOP_MODE_21>

          <!-- 单人基本信息 比如【综合性赛事】 -->
          <!-- <HTML_PLAYERDATACOMPARE_ADT
            v-if="themeItem.graphicsId == 3028"
            :datas="themeItem.renderData"
            :cssDynamicObj="cssDynamicObj"
          ></HTML_PLAYERDATACOMPARE_ADT> -->
          <HTML_PLAYERINFOR_BAR
            v-if="themeItem.graphicsId == 3028"
            :datas="themeItem.renderData"
            :cssDynamicObj="cssDynamicObj"
          ></HTML_PLAYERINFOR_BAR>

          <!-- graphicsId: 3029 -- 综合性运动会 对抗类 中网 表格 晋级之路 -->
          <COMBAT_MATCHROWTABLE_KNOCKOUT
            v-if="[3029].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :currSportsDetail="{
              sportsId: themeItem.disciplineId ? themeItem.disciplineId : 'TEN',
              sportsName: '',
              eventId: themeItem.eventId,
              eventName: '',
              matchId: '',
            }"
            themeClass="onlyDisplay"
            :sportCompetitionType="`${
              themeItem.sportType ? themeItem.sportType : 'tennis'
            }_${
              themeItem.competitionType
                ? themeItem.competitionType
                : 'chinaOpen'
            }`"
          ></COMBAT_MATCHROWTABLE_KNOCKOUT>

          <!-- graphicsId: 3030 -- 【头像+单行文字式表格】展示信息 -->
          <HTML_TABLEINFORTEXT
            v-if="themeItem.graphicsId == 3030"
            :datas="themeItem.renderData"
          ></HTML_TABLEINFORTEXT>

          <!-- graphicsId: 3031 -- 【球队+球员表格+表头前固定，表头后动态切更换指标项】展示信息 -->
          <HTML_TEAMFORPLAYERCOLUMN
            v-if="[3031, 3033].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :inFilter="themeItem.inFilter"
            :cssDynamicObj="cssDynamicObj"
            :graphicsId="`${themeItem.graphicsId}`"
            @inFilterChangeEvent="inFilterChangeEventHandler"
          ></HTML_TEAMFORPLAYERCOLUMN>

          <!-- graphicsId: 3032 --  球队数据对比  直接展示val string -->
          <HTML_PLAYERDATACOMPARE_svgCircle_T
            v-if="[3032].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :cssDynamicObj="cssDynamicObj"
            @inFilterChangeEvent="inFilterChangeEventHandler"
          ></HTML_PLAYERDATACOMPARE_svgCircle_T>

          <!-- graphicsId: 2001 -- 篮球联赛 | 足球联赛  球队排名 【支持竖向滚动】-->
          <HTML_LEAGUETEAMRANTABLE
            v-if="themeItem.graphicsId == 2001"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            themeRowClass=""
          ></HTML_LEAGUETEAMRANTABLE>

          <!-- graphicsId: 2002 -- 近期战绩 -->
          <HTML_RECENTACH
            v-if="themeItem.graphicsId == 2002"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_RECENTACH>

          <!-- graphicsId: 2003 -- 交锋纪录 -->
          <HTML_FACERECORD
            v-if="themeItem.graphicsId == 2003"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_FACERECORD>

          <!-- graphicsId: 2004 -- 篮球赛果 投篮热区图 单人|球队 -->
          <HTML_SHOOT_HOTSPOT
            v-if="themeItem.graphicsId == 2004 && cba_shootHotspotOpt"
            :currThemeObj="currThemeObj"
            :datas="themeItem.renderData"
            :isShowTip="true"
            :baseOpts="cba_shootHotspotOpt"
            :dynamicOpts="{ webKey: 'home', webType: 'themeItem' }"
          ></HTML_SHOOT_HOTSPOT>

          <!-- graphicsId: 2005 -- 篮球联赛赛程 -->
          <HTML_TODAYSCHEDULE
            v-if="themeItem.graphicsId == 2005"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :matchModeObj="matchModeObjHandler(themeItem)"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 2006 -- 篮球联赛赛程预告 -->
          <HTML_TODAYSCHEDULE
            v-if="themeItem.graphicsId == 2006"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :matchModeObj="matchModeObjHandler(themeItem)"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 2007 -- 篮球联赛 晋级图 -->
          <HTML_KNOCKOUT_T8T12
            v-if="themeItem.graphicsId == 2007"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            themeClass="onlyDisplay"
          ></HTML_KNOCKOUT_T8T12>

          <!-- graphicsId: 2010 -- 女子亚洲杯 -【晋级图】 -->
          <HTML_KNOCKOUT_T4T6T8
            v-if="themeItem.graphicsId == 2010"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :themeMode="['hideHeader']"
            themeClass="onlyDisplay"
          ></HTML_KNOCKOUT_T4T6T8>

          <!-- graphicsId: -- 单个球队表格 比如【足球 【支持竖向滚动】-->
          <HTML_COMBATLINEUP
            v-if="[2011].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :sportsId="'FIBAWA'"
            :modeType="'single'"
          ></HTML_COMBATLINEUP>

          <!-- graphicsId: -- 对抗类 双方首发阵容 表格类型; [2012:双方阵容+球员评分一起] 【支持竖向滚动】-->
          <HTML_COMBATLINEUP
            v-if="[2012].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :sportsId="'FIBAWA'"
            :modeType="'double'"
          ></HTML_COMBATLINEUP>

          <!-- graphicsId: -- 对抗类 羽毛球 出场名单 【支持竖向滚动】 4008双方球队全屏，4002单个球队半屏-->
          <HTML_THEMEITEM_MODE_11
            v-if="[4002, 4008].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :currSportsDetail="{ sportsId: 'BDM' }"
          ></HTML_THEMEITEM_MODE_11>

          <!-- graphicsId: 4003 -- 节目单 -->
          <HTML_COMMONPAGE_PRGGRAMLIST
            v-if="themeItem.graphicsId == 4003"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_COMMONPAGE_PRGGRAMLIST>

          <!-- graphicsId: 4004 -- 运动员对阵 【表格：代表团+运动员名字拼接+动态列】-->
          <HTML_THEMEITEM_MODE_6
            v-if="themeItem.graphicsId == 4004"
            :themeClass="'onlyDisplay'"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :currSportsDetail="{ sportsId: 'BDM' }"
          ></HTML_THEMEITEM_MODE_6>

          <!-- graphicsId: 4006 -- 羽毛球【汤尤杯】赛程预告 -->
          <HTML_TODAYSCHEDULE
            v-if="[4006].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :matchModeObj="{
              mode: 'badminton',
              type: 'groupName',
            }"
            viewMode="scheduleNoticeThomasAndUber"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 4007 -- 羽毛球【汤尤杯】今日赛程 -->
          <HTML_TODAYSCHEDULE
            v-if="[4007].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :matchModeObj="{
              mode: 'badminton',
              type: 'groupName',
            }"
          ></HTML_TODAYSCHEDULE>

          <!-- graphicsId: 4009 -- 羽毛球【汤尤杯】赛果里面的比赛详情 -->
          <HTML_MATCHDETAILINFOR
            v-if="themeItem.graphicsId == 4009"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
            :currSportsDetail="{ sportsId: 'BDM_TAU' }"
          ></HTML_MATCHDETAILINFOR>

          <!-- graphicsId: 11(足球世界杯) | 3018(综合性赛事) | 4001(羽毛球) -- 小组积分榜 【支持竖向滚动】-->
          <HTML_LEAGEUTABLE
            v-if="[11, 3018, 4001].includes(themeItem.graphicsId)"
            :datas="themeItem.renderData"
            :currThemeObj="currThemeObj"
          ></HTML_LEAGEUTABLE>
        </template>

        <!-- graphicsId: -- 测试组件 -->
        <!-- <HTML_TOPLISTBAR /> -->
      </div>
      <div class="themeItemLabelArr" v-if="themeItem.filterTypeNameLabel">
        <span
          class="labelItem"
          v-for="labelItem in JSON.parse(themeItem.filterTypeNameLabel)"
          :key="labelItem.key"
          v-text="labelItem.label"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import HTML_BAR_BOTHSIDEPLAYER from '@components/football/html/HTML_BAR/AbBothSidePlayerPerformance.vue'
import HTML_LEAGEUTABLE from '@components/compreSportsMeet/html/HTML_LEAGEUTABLE/index.vue'

import HTML_CARDLIST from '@components/compreSportsMeet/html/HTML_CARDLIST/index.vue'

import HTML_MEDIAPIC from '@components/compreSportsMeet/html/HTML_MEDIAPIC/index.vue'
import HTML_MEDIAVIDEO from '@components/compreSportsMeet/html/HTML_MEDIAVIDEO/index.vue'

import HTML_PLAYERINFOR from '@components/compreSportsMeet/html/HTML_PLAYERINFOR/index.vue'
import HTML_PLAYERINFOR_BAR from '@components/compreSportsMeet/html/HTML_PLAYERINFOR/bar_index.vue'
import HTML_MEDALIST from '@components/compreSportsMeet/html/HTML_MEDALIST/index.vue'
import HTML_WINTTEAM_T from '@components/compreSportsMeet/html/HTML_WINTEAM/winTeam_T.vue'
import HTML_WINTTEAM_AD from '@components/compreSportsMeet/html/HTML_WINTEAM/winTeam_AD.vue'
import HTML_BEYONDTHEMOMENT from '@components/compreSportsMeet/html/HTML_BEYONDTHEMOMENT/index.vue'
import HTML_RELAYMOMENT from '@components/compreSportsMeet/html/HTML_RELAYMOMENT/index.vue'
import HTML_PLAYERDATACOMPARE_ADT from '@components/compreSportsMeet/html/HTML_PLAYERDATACOMPARE/valTypeForString.vue'
import HTML_PLAYERDATACOMPARE_PER from '@components/compreSportsMeet/html/HTML_PLAYERDATACOMPARE/valTypeForPer.vue'
import HTML_PLAYERDATACOMPARE_svgCircle_T from '@components/compreSportsMeet/html/HTML_PLAYERDATACOMPARE/svgCircle_valTypeForString.vue'
import HTML_LOCALRESULT from '@components/compreSportsMeet/html/HTML_LOCALRESULT/index.vue'
import HTML_PERSONNAMEBAR from '@components/compreSportsMeet/html/HTML_PERSONNAMEBAR/index.vue'

import HTML_PLAYERTABLE from '@components/compreSportsMeet/html/HTML_PLAYERTABLE/index.vue'
import HTML_PLAYERTABLE_COMBAT from '@components/compreSportsMeet/html/HTML_PLAYERTABLE/combatAT_index.vue'
import HTML_COMBATTEAMFORTOP from '@components/compreSportsMeet/html/HTML_PLAYERTABLE/combatTeamForTop_index.vue'

import HTML_TODAYSCHEDULE from '@components/compreSportsMeet/html/HTML_SCHEDULE/todaySchedule.vue'
import HTML_EVENTPLAYERSSCHEDULE from '@components/compreSportsMeet/html/HTML_SCHEDULE/eventPlayersSchedule.vue'
import HTML_TODAYMEDALDETAIL from '@components/compreSportsMeet/html/HTML_MEADLPAGE/todayMedalDetail.vue'
import HTML_MEDALTALLY from '@components/compreSportsMeet/html/HTML_MEADLPAGE/medalTally.vue'
import HTML_COMBATLINEUP from '@components/compreSportsMeet/html/HTML_COMBATLINEUP/index.vue'
import HTML_TABLE_EVENTCOP_MODE_21 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_21.vue'

import HTML_MEDALTOP3 from '@components/compreSportsMeet/html/HTML_MEADLPAGE/medalTop3.vue'
// import HTML_DELEGATIONMEDALTALLY from '@components/compreSportsMeet/html/HTML_MEADLPAGE/delegationMedalTally.vue'
import HTML_DELEGATIONEVENTMEDALTALLY from '@components/compreSportsMeet/html/HTML_MEADLPAGE/delegationEventMedalTally.vue'
import HTML_TEAMFORPLAYERCOLUMN from '@components/compreSportsMeet/html/HTML_TEAMFORPLAYER/teamPlayer_column_index.vue'

// football
import HTML_FB_PLAYERINFOR from '@components/football/html/HTML_PLAYERINFOR/index.vue'
import HTML_FB_TEAMINFOR from '@components/football/html/HTML_TEAMINFOR/index.vue'
import HTML_FB_TEMAPLAYERINFOR_DOUBLE from '@components/football/html/HTML_TEMAPLAYERINFOR_DOUBLE/index.vue'
import HTML_SHOOTANALYSIS from '@components/football/html/HTML_SHOOTANALYSIS/index.vue'
import CANVAS_RADAR_PLAYERSINFOR from '@components/football/echarts/radar/playersInforRadar.vue'
import CANVAS_FB_BALLCONTROLCHAIN from '@components/football/echarts/ballControlChain/index.vue'
import HEATMAP from '@components/football/heatMap/cup_heatMap.vue'
import SITUATION_MAP from '@components/football/SituationMap.vue'
import MATCHSTATE_KEYEVENT_BAR from '@components/football/echarts/bar/matchState_keyEvent_bar.vue'
import WINRATEPREDICTION_BAR from '@components/football/echarts/bar/winRatePrediction_bar.vue'
import PLAYER_AVERAGEROCCUPANCY_SCATTER from '@components/football/echarts/scatter/player_averageOccupancy_scatter.vue'
import SHOOTDIS_EXPECTEDGOAL_SCATTER from '@components/football/echarts/scatter/shootingDistribution_expectedGoal_scatter.vue'
import PASSINGSTYLE_PIE from '@components/football/echarts/pie/passingStyle_pie.vue'
import CANVAS_PIE_COMLINEUP from '@components/football/echarts/pie/commonLineup.vue'
import html_FB_seasonMatch from '@components/football/html/HTML_DATAOVERVIEW/seasonMatch.vue'
import html_FB_seasonGoal from '@components/football/html/HTML_DATAOVERVIEW/seasonGoal.vue'
import html_FB_seasonGoalTime from '@components/football/html/HTML_DATAOVERVIEW/seasonGoalTime.vue'
import CANVAS_SHOOTINGSTEREOGRAM from '@components/football/canvas/shootingStereogram/index.vue'
import CANVAS_REGIONALCOVERAGE from '@components/football/canvas/regionalCoverage/index.vue'
import CANVAS_PIE_RECENTACH from '@components/football/echarts/pie/recentAchievements.vue'
import HTML_CONFRRECORD from '@components/football/html/HTML_CONFRRECORD/index.vue'
import HTML_KNOCKOUT_T4T6T8 from '@components/football/html/HTML_KNOCKOUT/teamsForT4OrT6OrT8.vue'
import HTML_LINEUP_SINGLETEAM from '@components/football/html/HTML_LINEUP/lineup_singleTeam.vue'
// import Lineup_doubleTeam from '@components/football/html/HTML_LINEUP/lineup_doubleTeam.vue'
import Complex_doubleTeam from '@components/football/html/HTML_LINEUP/complex_doubleTeam.vue'
import Lineup_horizontalPGA from '@components/football/html/HTML_LINEUP/lineup_horizontalPGA.vue'
import CANVAS_SCATTER_COORDINATSYS from '@components/football/echarts/scatter/coordinateSystemScatter.vue'
import CANVAS_GRAPH_EXPECTGOAL from '@components/football/echarts/graph/expectGoalScatter.vue'

import HTML_SIGNUPDATA from '@components/marathon/html/signupData.vue'
import PLAYERAGERADAR from '@components/marathon/echarts/radar/playerAgeRadar.vue'
import PLAYERDISTRIBUTEPIE from '@components/marathon/echarts/pie/playerDistributePie.vue'
import PLAYERCONTROLPIE from '@components/marathon/echarts/pie/playerControlPie.vue'

// basketball
import HTML_LEAGUETEAMRANTABLE from '@components/basketball/html/HTML_LEAGUETEAMRANTABLE/index.vue'
import HTML_FACERECORD from '@components/basketball/html/HTML_FACERECORD/index.vue'
import HTML_RECENTACH from '@components/basketball/html/HTML_RECENTACH/index.vue'
import HTML_SHOOT_HOTSPOT from '@components/basketball/html/HTML_SHOOT_HOTSPOT/index.vue'
import HTML_KNOCKOUT_T8T12 from '@components/basketball/html/HTML_KNOCKOUT/teamsForT8OrT12.vue'

import HTML_TOPLISTBAR from '@components/compreSportsMeet/html/HTML_SpecialEffects/topList_bar.vue'

// badminton
import HTML_THEMEITEM_MODE_6 from '@components/badminton/html/table/themeItem_mode_6.vue'
import HTML_THEMEITEM_MODE_11 from '@components/badminton/html/table/themeItem_mode_11.vue'
import HTML_MATCHDETAILINFOR from '@components/badminton/html/HTML_MATCHDETAILINFOR/index.vue'

// tennis
import TENNIS_RADAR_PLAYERINFOR from '@components/tennis/echarts/PlayerInforRadar.vue'
import TENNIS_TRACE from '@components/tennis/trace.vue'

// programList
import HTML_COMMONPAGE_PRGGRAMLIST from '@components/commonPage/programList/HTML_PRGGRAMLIST/index.vue'

import COMBAT_DYNAMICDENDRIFORM_KNOCKOUT from '@components/compreSportsMeet/html/HTML_KNOCKOUT/combat_dynamicDendriform.vue'
import COMBAT_MATCHROWTABLE_KNOCKOUT from '@components/compreSportsMeet/html/HTML_KNOCKOUT/combat_matchRow_table.vue'

import HTML_TABLEINFORTEXT from '@components/compreSportsMeet/html/HTML_TABLEINFORTEXT/index.vue'

import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_themeItem',
  mixins: [cup_base_data_mixin],
  components: {
    HTML_BAR_BOTHSIDEPLAYER,
    HTML_LEAGEUTABLE,
    HTML_CARDLIST,

    HTML_MEDIAPIC,
    HTML_MEDIAVIDEO,
    HTML_PLAYERINFOR,
    HTML_PLAYERINFOR_BAR,
    HTML_MEDALIST,
    HTML_WINTTEAM_T,
    HTML_BEYONDTHEMOMENT,
    HTML_RELAYMOMENT,
    HTML_PLAYERDATACOMPARE_ADT,
    HTML_PLAYERDATACOMPARE_PER,
    HTML_PLAYERDATACOMPARE_svgCircle_T,
    HTML_WINTTEAM_AD,
    HTML_LOCALRESULT,
    HTML_PERSONNAMEBAR,
    HTML_PLAYERTABLE,
    HTML_PLAYERTABLE_COMBAT,
    HTML_COMBATTEAMFORTOP,
    HTML_TODAYSCHEDULE,
    HTML_TODAYMEDALDETAIL,
    HTML_MEDALTALLY,
    HTML_COMBATLINEUP,
    HTML_TABLE_EVENTCOP_MODE_21,
    HTML_MEDALTOP3,
    HTML_EVENTPLAYERSSCHEDULE,
    // HTML_DELEGATIONMEDALTALLY,
    HTML_DELEGATIONEVENTMEDALTALLY,
    HTML_TEAMFORPLAYERCOLUMN,

    HTML_FB_PLAYERINFOR,
    HTML_FB_TEAMINFOR,
    HTML_FB_TEMAPLAYERINFOR_DOUBLE,
    HTML_SHOOTANALYSIS,
    CANVAS_RADAR_PLAYERSINFOR,
    TENNIS_RADAR_PLAYERINFOR,
    CANVAS_FB_BALLCONTROLCHAIN,
    HEATMAP,
    SITUATION_MAP,
    MATCHSTATE_KEYEVENT_BAR,
    WINRATEPREDICTION_BAR,
    PLAYER_AVERAGEROCCUPANCY_SCATTER,
    SHOOTDIS_EXPECTEDGOAL_SCATTER,
    PASSINGSTYLE_PIE,
    CANVAS_PIE_COMLINEUP,
    html_FB_seasonMatch,
    html_FB_seasonGoal,
    html_FB_seasonGoalTime,
    CANVAS_SHOOTINGSTEREOGRAM,
    CANVAS_REGIONALCOVERAGE,
    CANVAS_PIE_RECENTACH,
    HTML_CONFRRECORD,
    HTML_KNOCKOUT_T4T6T8,
    // HTML_LINEUP_SINGLETEAM,
    // Lineup_doubleTeam,
    Complex_doubleTeam,
    Lineup_horizontalPGA,
    CANVAS_SCATTER_COORDINATSYS,
    CANVAS_GRAPH_EXPECTGOAL,

    HTML_SIGNUPDATA,
    PLAYERAGERADAR,
    PLAYERDISTRIBUTEPIE,
    PLAYERCONTROLPIE,

    HTML_LEAGUETEAMRANTABLE,
    HTML_FACERECORD,
    HTML_RECENTACH,
    HTML_SHOOT_HOTSPOT,
    HTML_KNOCKOUT_T8T12,

    HTML_THEMEITEM_MODE_6,
    HTML_THEMEITEM_MODE_11,
    HTML_MATCHDETAILINFOR,
    COMBAT_DYNAMICDENDRIFORM_KNOCKOUT,
    COMBAT_MATCHROWTABLE_KNOCKOUT,

    HTML_COMMONPAGE_PRGGRAMLIST,
    HTML_TABLEINFORTEXT,
    TENNIS_TRACE,
    // HTML_TOPLISTBAR,
  },
  props: {
    themeItem: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: '',
    },
    width100ThemeGraphicsIds: {
      type: Array,
      default: () => {
        return []
      },
    },
    width100ThemeGraphicsIdsClassName: {
      type: Array,
      default: () => {
        return []
      },
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  watch: {
    themeItem: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          console.debug('themeItem 重新刷新数据 1:', newVal, oldVal)
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // 2004 start 主题需要的配置项
      cba_shootHotspotOpt: null,
      // 2004 end
      sportsTypeArr: ['combat', 'uncombat'],
    }
  },
  computed: {
    themeClipPathSize() {
      let titleHeightPx = Math.ceil(2.5 * this.vw2px)
      let scale = this.cssDynamicObj.mixvw
      let half_titleHeightPx = Math.ceil(titleHeightPx / 2)
      return `path('M 0,0 C ${(half_titleHeightPx * scale).toFixed(2)},0 ${(
        half_titleHeightPx * scale
      ).toFixed(2)},${(titleHeightPx * scale).toFixed(2)} ${(
        titleHeightPx * scale
      ).toFixed(2)},${(titleHeightPx * scale).toFixed(2)} L 0, ${(
        titleHeightPx * scale
      ).toFixed(2)} Z')`
    },
  },
  created() {
    console.debug('themeItem:', this.themeItem)
    let cba_shootHotspotOpt = {
      // 初始化时就设置好的，不会变
      svgKeyArr: ['name', 'val'], // 数据中需要的映射的字段名['name', 'val']
      svgCenterInforArr: ['val', 'name'], // 中间显示的内容；['name', 'val']
      strokeWidthVw: 0.278, //描边宽度
      cxVw: 2.6, //圆点 x坐标
      cyVw: 2.6, //圆点 y坐标
      echartsIconTipArr: ['投篮命中', '投篮未命中'],
      echartsHotSpotIconArr:
        this.currThemeObj.image &&
        this.currThemeObj.image.echartsHotSpotIconArr &&
        this.currThemeObj.image.echartsHotSpotIconArr
          ? this.currThemeObj.image.echartsHotSpotIconArr
          : null, // 热区图 图标，赛事不同图标颜色可能会不一样
    }
    this.cba_shootHotspotOpt = cba_shootHotspotOpt
  },
  methods: {
    inFilterChangeEventHandler(childData) {
      this.$emit('inFilterChangeEvent', childData)
    },
    matchModeObjHandler(themeItem) {
      let matchModeObj = {}
      if (themeItem) {
        if (
          themeItem.sportType === 'football' &&
          ['cup', 'asianPreCup'].includes(themeItem.competitionType)
        ) {
          matchModeObj = {
            mode: 'FIFAWorldCup',
          }
        } else if (
          themeItem.sportType === 'football' &&
          themeItem.competitionType === 'league'
        ) {
          matchModeObj = {
            mode: 'FootballLeague',
          }
        } else if (
          themeItem.sportType === 'basketball' &&
          themeItem.competitionType === 'league'
        ) {
          matchModeObj = {
            mode: 'BasketballLeague',
          }
        }
      }
      return matchModeObj
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_box {
  /* --clipPathSize: path('M 0,0 C 19,0 19,38 38,38 L 0, 38 Z'); */
  width: 100%;
  /* height: 24.04vw; */
  height: calc((24.686vw + var(--insidePadSize)) * var(--mixtmt_mixvw));
  padding: 0 var(--insidePadSize) var(--insidePadSize) var(--insidePadSize);
  background-color: var(--mixtmt_greyColor12);
  overflow: hidden;
  border-radius: 0 0 var(--outsideRadiusSize) var(--outsideRadiusSize);
  /* &.broadcastList {
    .themeItem_title {
      font-size: 0.972vw;
    }
  } */
  &.width100 {
    height: auto;
    .themeItemMain_bg {
      .themeItem_main {
        margin: 0 1.11vw;
        width: calc(100% - 2.22vw * var(--mixtmt_mixvw));
        height: auto;
        align-items: flex-start;
      }
    }
    &.height27s5vw {
      .themeItemMain_bg {
        .themeItem_main {
          max-height: calc(27.5vw * var(--mixtmt_mixvw));
          overflow-y: auto;
        }
      }
    }
    &.height31vw {
      .themeItemMain_bg {
        .themeItem_main {
          max-height: calc(31vw * var(--mixtmt_mixvw));
          overflow-y: auto;
        }
      }
    }
    &.height27vw {
      .themeItemMain_bg {
        .themeItem_main {
          max-height: calc(27vw * var(--mixtmt_mixvw));
          overflow-y: auto;
        }
      }
    }
    &.borderR694 {
      .themeItemMain_bg {
        .themeItem_main {
          border-radius: calc(0.694vw * var(--mixtmt_mixvw));
        }
      }
    }
    &.mtb1388 {
      .themeItemMain_bg {
        .themeItem_main {
          margin: calc(1.11vw * var(--mixtmt_mixvw));
        }
      }
    }
    &.mtb694 {
      .themeItemMain_bg {
        .themeItem_main {
          margin: calc(0.694vw * var(--mixtmt_mixvw))
            calc(1.11vw * var(--mixtmt_mixvw));
        }
      }
    }
    &.positionRela {
      position: relative;
    }
    &.fillPer100 {
      .themeItemMain_bg {
        .themeItem_main {
          margin: 0;
          width: 100%;
        }
      }
    }
    &.themeContainH28vw {
      height: calc(28vw * var(--mixtmt_mixvw));
    }
  }
  .themeItem_title {
    position: relative;
    width: 100%;
    height: calc(2.5vw * var(--mixtmt_mixvw));
    background-color: var(--mixtmt_greyColor12);
    font-size: calc(1.11vw * var(--mixtmt_mixvw));
    text-align: center;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--insideRadiusSize) 0 0 0;
    overflow: hidden;
    .themeItemTitle_bg {
      pointer-events: none;
      position: absolute;
      top: 0;
      z-index: 5;
      transition: left 0.3s ease-in-out;
      left: 0;
      width: 80%;
      .actTab {
        display: block;
        background: var(--mixtmt_whiteColor);
        width: calc(100% - 1vw * var(--mixtmt_mixvw));
        height: calc(2.5vw * var(--mixtmt_mixvw));
        position: relative;
        border-radius: var(--insideRadiusSize) 0 0 0;
        /* &::before {
          content: '\20';
          background-image: radial-gradient(
            circle at 30% 70%,
            rgba(255, 255, 255, 0) 1.94vw,
            #fff 0
          );
          position: absolute;
          bottom: -0.555vw;
          right: 100%;
          width: 2.083vw;
          height: 3.47vw;
          transform: perspective(1.388vw) rotate(89deg);
        } */
        /* &::after {
          content: '\20';
          background-image: radial-gradient(
            circle at 90% 20%,
            rgba(255, 255, 255, 0) 0.8vw,
            #fff 0
          );
          position: absolute;
          bottom: -32%;
          left: 95%;
          width: 2.74vw;
          height: 2vw;
          transform: rotate(-360deg);
        } */
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: calc(-3.47vw);
          height: 100%;
          width: calc(3.47vw);
          z-index: 2;
          background-color: var(--mixtmt_whiteColor);
          clip-path: var(--mixtmt_themeClipPathSize);
        }
      }
    }
    .themeItemTitle_name {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      width: 80%;
      height: 100%;
      padding: 0 calc(0.694vw * var(--mixtmt_mixvw)) 0
        calc(1.388vw * var(--mixtmt_mixvw));
      display: block;
      font-size: calc(1.25vw * var(--mixtmt_mixvw));
      line-height: calc(2.5vw * var(--mixtmt_mixvw));
      font-weight: bold;
      text-align: left;
      color: var(--mixtmt_greyColor3);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      &::before {
        position: absolute;
        left: calc(0.694vw * var(--mixtmt_mixvw));
        top: 20%;
        z-index: 2;
        content: '\20';
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: calc(0.2083vw * var(--mixtmt_mixvw));
        height: 60%;
        background-color: var(--mixtmt_mainColor0);
        border-radius: calc(0.138vw * var(--mixtmt_mixvw));
      }
    }
    .themeItemTitle_styleName {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10;
      width: 20%;
      height: 100%;
      padding: 0 calc(0.694vw * var(--mixtmt_mixvw));
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      font-size: calc(0.833vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor2);
    }
  }
  .themeItemMain_bg {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    /* flex-direction: column; */
    width: 100%;
    height: calc(100% - 2.5vw * var(--mixtmt_mixvw));
    background-color: var(--mixtmt_whiteColor);
    border-radius: 0 var(--insideRadiusSize) var(--insideRadiusSize)
      var(--insideRadiusSize);
    overflow: auto;
    .themeItem_main {
      /* position: absolute;
      top: 0;
      left: 0;
      z-index: 10; */
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    .themeItemLabelArr {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 1.1vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 1.25vw;
      .labelItem {
        width: auto;
        margin-right: 0.347vw;
        padding: 0 0.55vw;
        font-size: 0.694vw;
        line-height: 1.1vw;
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_greyColor2);
        border-radius: 0.25vw;
      }
    }
  }
}
</style>
